import styled, { css } from 'styled-components';

export const FavouritesWrapper = styled.div`
  position: fixed;
  opacity: 0;
  z-index: 900;
  bottom: 0.5em;
  right: 0.5em;
  background-color: ${props => props.theme.colors.selectedColor};;
  cursor: pointer;
  height: 3em;
  width: 3em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%; 
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size:16px;
  line-height:22px;
  float: right;
  
  ${props => props.theme.mediaQueries.tablet_big_down}{
    height: 3em;
  };
`;

export const NumberSpan = styled.span`
  position: absolute;
  color: ${props => props.theme.colors[props.color]};
  font-size: ${props => props.size}px;
  margin-top: 2%;
  ${props => (props.font) && css` 
    font-family: ${props.theme.fontSets[props.font]};
  `};
`;
